import type { DeviceInfo } from "@wolzienllc/vcc-react-commons";
import { store } from "../state";
import {
  setCallEnded,
  setCallStarted,
  setQueueState,
  setParticipantData,
  setError,
  setNetworkDiagnosticParams,
  setZoomMeetingLink,
  setNextomeetGuestLink,
} from "../state/actions";
import {
  CallData,
  QueueState,
  NetworkDiagnosticParams,
  Participant,
  PageErrorType,
} from "../state/types";

export interface ListenEvents {
  [event: string]: (...args: any[]) => void;
}

export const eventListeners: ListenEvents = {
  call: (data: CallData) => store.dispatch(setCallStarted(data)),
  endCall: () => store.dispatch(setCallEnded()),
  invitationInUse: (data?: { deviceInfo?: DeviceInfo }) =>
    store.dispatch(
      setError({
        type: PageErrorType.InvitationInUse,
        deviceInfo: data?.deviceInfo,
      })
    ),
  invitationCancelled: () =>
    store.dispatch(setError({ type: PageErrorType.InvitationCancelled })),
  startNetworkDiagnostic: (data: NetworkDiagnosticParams) =>
    store.dispatch(setNetworkDiagnosticParams(data)),
  stopNetworkDiagnostic: () => store.dispatch(setNetworkDiagnosticParams(null)),
  stateChanged: (data: { response: QueueState }) =>
    store.dispatch(setQueueState(data.response)),
  updateInfoResponse: (data: { response: Participant }) =>
    store.dispatch(setParticipantData(data.response)),
  zoomMeetingLink: (data: { zoomMeetingLink: string }) => {
    store.dispatch(setZoomMeetingLink(data.zoomMeetingLink));
  },
  nextomeetLink: (data: { nextomeetLink: string }) => {
    console.log("emit handler for nextomeetLink");
    console.dir(data);
    store.dispatch(setNextomeetGuestLink(data.nextomeetLink));
  },
};
